import { EventCreateDialogEditorOutput } from './event-create-dialog-editor-output';

export const defaultEventCreateDialogEditorOutput: EventCreateDialogEditorOutput = {
  startTime: '',
  endTime: '',
  isRepeating: false,
  rrule: '',
  repeatEnd: '',
  repeatEndDate: '',
  extendScheduleNumDays: 90,
  assignedUserId: '',
  assignedBackupUserId: '',
};
